import React, {ReactElement} from 'react';
import {NxTableActionsProps} from './NxTableTypes';
import NxRow, {NxRowPosition} from '../nxRow/NxRow';
import styles from './NxTableActions.scss';

export class NxTableActions<RowData> extends React.Component<NxTableActionsProps<RowData>> {
  render(): ReactElement | null{
    const {data, size, actions, materialTableRef, disabled} = this.props;
    if (!actions) {
      return null;
    }

    return <div className={styles.container}>
        <NxRow position={NxRowPosition.END}>
        {
          this.props.actions.map((action, index) => (
            <this.props.components.Action
              key={index}
              action={action}
              data={data}
              size={size}
              api={{
                onDataUpdated: (): void => {
                  const matTable = materialTableRef.current;
                  if(!matTable) {
                    // either material table is not initialized or someone already left the page
                    return;
                  }

                  if(!matTable.isRemoteData()) {
                    throw new Error('OnDataUpdated can only be called for remote data')
                  }

                  matTable.onQueryChange();
                }
              }}
              disabled={disabled}
            />
          ))
        }
      </NxRow>
    </div>
  }
}

export default NxTableActions;